import { useContext } from 'react';

import SessionContext from '../contexts/sessionContext';

const useSession = () => useContext(SessionContext);

export default useSession;
